import type { StickerStatus } from '../../types';

type ViewMode = 'grid' | 'list' | 'team' | 'group' | 'check';

interface StickerFiltersProps {
  status: StickerStatus | 'ALL';
  onStatusChange: (status: StickerStatus | 'ALL') => void;
  view: ViewMode;
  onViewChange: (view: ViewMode) => void;
}

const statusConfig: Array<{
  value: StickerStatus | 'ALL';
  label: string;
  activeClass: string;
}> = [
  { value: 'ALL',      label: 'Todas',      activeClass: 'bg-night text-white border-night' },
  { value: 'FALTA',    label: 'Faltan',     activeClass: 'bg-red-500 text-white border-red-500' },
  { value: 'TENGO',    label: 'Tengo',      activeClass: 'bg-emerald-500 text-white border-emerald-500' },
  { value: 'DUPLICADA',label: 'Duplicadas', activeClass: 'bg-amber-400 text-white border-amber-400' },
];

const viewConfig: Array<{ value: ViewMode; icon: string; label: string }> = [
  { value: 'grid',  icon: '⊞',  label: 'Cuadrícula' },
  { value: 'list',  icon: '☰',  label: 'Lista' },
  { value: 'team',  icon: '🔤', label: 'Por selección' },
  { value: 'group', icon: '🌍', label: 'Por grupo' },
  { value: 'check', icon: '✓',  label: 'Checklist' },
];

export function StickerFilters({ status, onStatusChange, view, onViewChange }: StickerFiltersProps) {
  return (
    <div className="flex items-center gap-2">
      {/* Status pills — horizontally scrollable on mobile */}
      <div className="flex gap-1.5 overflow-x-auto scrollbar-none flex-shrink min-w-0 pb-0.5">
        {statusConfig.map((s) => (
          <button
            key={s.value}
            onClick={() => onStatusChange(s.value)}
            className={[
              'px-3.5 py-1.5 rounded-full text-xs font-bold border transition-all',
              status === s.value
                ? s.activeClass
                : 'bg-white text-gray-500 border-gray-200 hover:border-gray-400 hover:text-gray-700',
            ].join(' ')}
          >
            {s.label}
          </button>
        ))}
      </div>

      {/* View toggle */}
      <div className="ml-auto flex gap-1 bg-white rounded-xl border border-gray-200 p-0.5">
        {viewConfig.map((v) => (
          <button
            key={v.value}
            onClick={() => onViewChange(v.value)}
            title={v.label}
            className={[
              'w-8 h-7 rounded-lg text-sm flex items-center justify-center transition-all',
              view === v.value
                ? 'bg-night text-white shadow-sm'
                : 'text-gray-400 hover:text-gray-600',
            ].join(' ')}
          >
            {v.icon}
          </button>
        ))}
      </div>
    </div>
  );
}

export type { ViewMode };
